import { createStructuredSelector } from 'reselect';
import { bool, func, shape } from 'prop-types';
import { selectIsLoading, select_dedupeVerifySuccess, select_indusindMinKycCities, select_indusindMinKycUser, select_indusindMinKycUserDetails, select_indusindMinKycUserInfo } from './selectors';
import { dedupeVerify, indusindMinKycCities, indusindMinKycUpdate, indusindMinKycUserDetails, indusindMinKycUserInfo } from './actions';
import { getUpdatedUserProfile, resetPopup } from '../HeaderContainer/actions';
import { SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS } from './constants';
import { selectUserDetails } from '../HeaderContainer/selectors';
import { select_generateOtpYsc, select_otp_response, isLoading } from '../PayBalance/selectors';
import { PAY_BALANCE_CONSTANT } from '../PayBalance/constants';
import { submitOtp, generateYscOtp } from '../PayBalance/actions';

/**
* @class IndusindMinKyc
*/

const IndusindMinKycProps = {
  isLoadingStatus: bool.isRequired,
  isLoading: bool.isRequired,
  history: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  IndusindMinKycUserUpdateSuccess: shape({}).isRequired,
  UserDetails: shape({}).isRequired,
  MinKycUserDetails: shape({}).isRequired,
  GenerateOtpIndusInd: shape({}).isRequired,
  OtpSubmitResponse: shape({}).isRequired,
  DedupeVerifySuccess: shape({}).isRequired,
  onInitIndusindMinKycCities: func.isRequired,
  onInitIndusindMinKycUserInfo: func.isRequired,
  onInitIndusindMinKycUpdate: func.isRequired,
  onInitUpdatedUserProfile: func.isRequired,
  onResetIndusindMinKycUserInfo: func.isRequired,
  onInitGetMinKycUserDetails: func.isRequired,
  onGenerateYscOtp: func.isRequired,
  onGetOtpSuccess: func.isRequired,
  onResetPopup: func.isRequired,
  onOtpCaptureAction: func.isRequired,
  onDedupeVerify: func.isRequired,
};

const IndusindMinKycDispatchToProps = (dispatch) => ({
  onInitIndusindMinKycCities: (payload) => dispatch(indusindMinKycCities(payload)),
  onInitIndusindMinKycUserInfo: (payload) => dispatch(indusindMinKycUserInfo(payload)),
  onInitIndusindMinKycUpdate: (payload) => dispatch(indusindMinKycUpdate(payload)),
  onInitUpdatedUserProfile: () => dispatch(getUpdatedUserProfile()),
  onResetIndusindMinKycUserInfo: (payload) => dispatch({ type: SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS, payload }),
  onInitGetMinKycUserDetails: () => dispatch(indusindMinKycUserDetails()),
  onGenerateYscOtp: (payload) => dispatch(generateYscOtp(payload)),
  onGetOtpSuccess: () => dispatch({ type: PAY_BALANCE_CONSTANT.SET_GENERATE_OTP_YSC, payload: { status: false } }),
  onResetPopup: (payload, actionType, alertType) => dispatch(resetPopup(payload, actionType, alertType)),
  onOtpCaptureAction: (payload) => dispatch(submitOtp(payload)),
  onDedupeVerify: (payload) => dispatch(dedupeVerify(payload)),
});

const IndusindMinKycmapStateToProps = createStructuredSelector({
  isLoadingStatus: selectIsLoading(),
  isLoading: isLoading(),
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
  IndusindMinKycUserUpdateSuccess: select_indusindMinKycUser(),
  UserDetails: selectUserDetails(),
  MinKycUserDetails: select_indusindMinKycUserDetails(),
  GenerateOtpIndusInd: select_generateOtpYsc(),
  OtpSubmitResponse: select_otp_response('otp_response'),
  DedupeVerifySuccess: select_dedupeVerifySuccess(),
});

/**
* @class PersonalAddressForm
*/

const PersonalAddressFormProps = {
  form: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  formValues: shape({}).isRequired,
  onInitIndusindMinKycCities: func.isRequired,
};

const PersonalAddressFormmapStateToProps = createStructuredSelector({
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
});

/**
* @class ResidentialAddressForm
*/

const ResidentialAddressFormProps = {
  checkboxValue: bool.isRequired,
  form: shape({}).isRequired,
  IndusindMinKycCities: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  formValues: shape({}).isRequired,
  residentialAddressValues: shape({}).isRequired,
  preferredAddressValues: shape({}).isRequired,
  handleNextStep: func.isRequired,
  handlePrevStep: func.isRequired,
  onInitIndusindMinKycCities: func.isRequired,
};

const ResidentialAddressFormmapStateToProps = createStructuredSelector({
  IndusindMinKycCities: select_indusindMinKycCities(),
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
});

/**
* @class WorkAddressForm
*/

const WorkAddressFormProps = {
  checkboxValue: bool.isRequired,
  isLoadingStatus: bool.isRequired,
  form: shape({}).isRequired,
  IndusindMinKycCities: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  formValues: shape({}).isRequired,
  workAddressValues: shape({}).isRequired,
  handlePrevStep: func.isRequired,
  handleFormSubmit: func.isRequired,
  onInitIndusindMinKycCities: func.isRequired,
};


const WorkAddressFormmapStateToProps = createStructuredSelector({
  IndusindMinKycCities: select_indusindMinKycCities(),
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
});

export {
  IndusindMinKycProps,
  IndusindMinKycmapStateToProps,
  IndusindMinKycDispatchToProps,
  PersonalAddressFormProps,
  ResidentialAddressFormProps,
  WorkAddressFormProps,
  PersonalAddressFormmapStateToProps,
  ResidentialAddressFormmapStateToProps,
  WorkAddressFormmapStateToProps,
};



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/IndusindMinKycDataHandler.js